module.exports = __webpack_public_path__ + "static/media/micronaut.4af23e1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/micronaut.svg
// module id = 511
// module chunks = 0